// extracted by mini-css-extract-plugin
export var infoItem = "_oz-2";
export var title = "_oz-0";
export var value = "_oz-1";